import { createAction } from 'redux-actions';
import callApi, {
  isDevEnvironmentUrl,
  isStageEnvironmentUrl,
} from '../../../utils/api/axios';
import {
  RMDEndpoint,
  rmdMinimumDistribution,
  submitRMDapi,
} from '../../../utils/api/api-endpoint-dictionary';
import { tablePagination } from '../../../utils/dashboard-utils';

const ACKNOWLEDGE_RMD_DISCLAIMER = 'ACKNOWLEDGE_RMD_DISCLAIMER';
const RMD_INFORMATION = 'RMD_INFORMATION';
const EXISTING_RMD = 'EXISTING_RMD';
const DELETE_RMD = 'DELETE_RMD';
const RMD_MINIMUM_DISTRIBUTION = 'RMD_MINIMUM_DISTRIBUTION';
const SET_LOADING = 'SET_LOADING';
const RESET_RMD_MINIMUM_DISTRIBUTION = 'RESET_RMD_MINIMUM_DISTRIBUTION';
const DEFAULT_STATE = {
  disclaimerAccepted: false,
  deleteLoading: false,
  deleteLoaded: false,
  deleteFailed: false,
  isLoading: false,
  isLoaded: false,
  isRMDCalculatorLoading: false,
  isRMDCalculatorLoaded: false,
  hasFailed: false,
  hasRMDCalculatorFailed: false,
  existingIsLoading: false,
  existingIsLoaded: false,
  existingHasFailed: false,
  existingRMDData: [],
  existingRMDDataPending: {},
  error: null,
  rmdLimitsData: {},
  rmdMinimumDistribution: null,
};

export default function RMDSetting(state = DEFAULT_STATE, { payload, type }) {
  switch (type) {
    case ACKNOWLEDGE_RMD_DISCLAIMER: {
      const disclaimerAccepted = payload;
      return {
        ...state,
        disclaimerAccepted,
      };
    }
    case `${RMD_INFORMATION}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };
    case `${RMD_INFORMATION}_FULFILLED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        rmdLimitsData: {
          ...payload.data.rmdSummary,
          pagination: tablePagination(payload.data.rmdSummary.retirementPlans),
        },
        existingIsLoaded: true,
        existingIsLoading: false,
        existingRMDData: payload.data.systematicActivityRMDs
          ? payload.data.systematicActivityRMDs
          : [],
        deleteLoading: false,
        showDashboard: payload.data.showDashboard,
        dashboardStatus: payload.data.dashboardStatus,
      };
    case `${RMD_INFORMATION}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        hasError: true,
        rmdLimitsData: {},
        error: payload,
      };
    case `${EXISTING_RMD}_PENDING`:
      return {
        ...state,
        existingIsLoaded: false,
        existingIsLoading: true,
        deleteLoading: true,
      };
    case `${EXISTING_RMD}_FULFILLED`:
      return {
        ...state,
        existingIsLoaded: true,
        existingIsLoading: false,
        existingRMDDataPending: payload.data,
        deleteLoading: false,
      };

    case `${EXISTING_RMD}_REJECTED`:
      return {
        ...state,
        existingIsLoaded: true,
        existingIsLoading: false,
        existingHasError: true,
        existingRMDDate: {},
        deleteLoading: false,
        error: payload,
      };
    case `${DELETE_RMD}_PENDING`:
      return {
        ...state,
        deleteLoaded: false,
        deleteLoading: true,
        deleteFailed: false,
      };
    case `${DELETE_RMD}_REJECTED`:
      return {
        ...state,
        deleteLoading: false,
        deleteFailed: true,
      };
    case `${DELETE_RMD}_FULFILLED`:
      return {
        ...state,
        deleteLoaded: true,
        deleteLoading: false,
      };
    case `${RMD_MINIMUM_DISTRIBUTION}_PENDING`:
      return {
        ...state,
        isRMDCalculatorLoading: true,
        hasRMDCalculatorFailed: false,
      };
    case `${RMD_MINIMUM_DISTRIBUTION}_REJECTED`:
      return {
        ...state,
        isRMDCalculatorLoading: false,
        hasRMDCalculatorFailed: true,
      };
    case `${RMD_MINIMUM_DISTRIBUTION}_FULFILLED`:
      return {
        ...state,
        isRMDCalculatorLoading: false,
        isRMDCalculatorLoaded: true,
        rmdMinimumDistribution: payload.data,
      };
    case SET_LOADING:
      return { ...state, deleteLoaded: false, deleteLoading: true };
    case RESET_RMD_MINIMUM_DISTRIBUTION:
      return { ...state, rmdMinimumDistribution: null };
    default:
      return state;
  }
}

export const updateDisclaimerRMD = (disclaimerAccepted) => {
  return createAction(ACKNOWLEDGE_RMD_DISCLAIMER)(disclaimerAccepted);
};

export const getRMDLimits = () => {
  let businessDate;
  if (isDevEnvironmentUrl() || isStageEnvironmentUrl) {
    businessDate = new URLSearchParams(window.location.search).get(
      'businessDate'
    );
  }
  const rmdSummaryEndpoint =
    RMDEndpoint +
    (businessDate ? `?businessDate=${encodeURIComponent(businessDate)}` : '');
  return (dispatch) => {
    const action = createAction(RMD_INFORMATION)(callApi(rmdSummaryEndpoint));
    try {
      return dispatch(action);
    } catch (e) {
      console.error(e);
    }
  };
};
export const setLoader = () => {
  return (dispatch) => {
    try {
      return dispatch({type: SET_LOADING});
    } catch (e) {
      console.error(e);
    }
  };
};
export const deleteExistingRMD = (payload) => {
  return (dispatch) => {
    const action = createAction(DELETE_RMD)(
      callApi(
        submitRMDapi,
        { method: 'delete', requestBody: payload },
        false,
        process.env.NODE_ENV === 'development'
      )
    );
    try {
      return dispatch(action);
    } catch (e) {
      console.error(e);
    }
  };
};

export const resetRMDCalc = () => {
  return (dispatch) => {
    try {
      return dispatch({ type: RESET_RMD_MINIMUM_DISTRIBUTION });
    } catch (e) {
      console.error(e);
    }

  };
};

export const getRmdMinimumDistribution = (payload) => {
  return (dispatch) => {
    const action = createAction(RMD_MINIMUM_DISTRIBUTION)(
      callApi(
        rmdMinimumDistribution,
        { method: 'POST', requestBody: payload },
        false,
        process.env.NODE_ENV === 'development'
      )
    );
    return dispatch(action);
  };
};
